import { callApi } from "./service";

const dashboardApi = process.env.REACT_APP_DASHBOARD_API;

export function* getMetaTags() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/seo/meta-tags-new`,
    params: {},
  };
  return yield callApi(payload);
}

export function* editMetaTags(data) {
  const payload = {
    method: "PATCH",
    url: `${dashboardApi}/seo/meta-tags-new`,
    params: data.payload,
  };
  return yield callApi(payload);
}
